import React from 'react';
export default function DiIcon(props) {
    return React.createElement(
        'div',
        { className: 'icon ' + props.className, onClick: props.onClick },
        props.icon,
        props.text && React.createElement(
            'span',
            { className: props.icon ? '' : 'noicon' },
            props.text
        )
    );
}